import React from 'react';
import { Form, Button, Row, Col, Card, Alert, Modal } from 'react-bootstrap';

import { render_site_critical_findings } from '../utils/CriticalFindings';

// on_ask_ai, when given, shows an Ask AI button that asks the AEO Assistant about this site analysis.
const SiteAnalysisSummary = ({site_analysis, on_pdf_export, analyzing, fetching_pdf, on_ask_ai})=>{
	const scoring = (site_analysis && site_analysis.scoring) ? site_analysis.scoring : null;

	// { overall_score, grade }, which the backend computes and sends with the site analysis.
	const analysis_grade = (site_analysis && site_analysis.analysis_grade) ? site_analysis.analysis_grade : null;

    if(!scoring){
        return;
    }

    const get_color_class = (v)=>{
        if(v <= 25){
            return "score-red";
        }else{
            if(v <= 50){
                return "score-orange";
            }else{
                if(v <= 75){
                    return "score-yellow";
                }else{
                    return "score-green";
                }
            }
        }
    };

	// The grade box is colored by the letter, so it always agrees with the grade bands the backend uses.
	const get_grade_color_class = (grade)=>{
		if(grade === 'D'){
			return "score-red";
		}

		if(grade === 'C'){
			return "score-orange";
		}

		if(grade === 'B'){
			return "score-yellow";
		}

		return "score-green";
	};

	// The grade box: the backend's grade, or the label alone until it has loaded.
	const render_grade_box = ()=>{
		if(!analysis_grade){
			return (
				<div className="grade-score-box">
					<div className="grade-label">Grade</div>
				</div>
			);
		}

		return (
			<div className={"grade-score-box " + get_grade_color_class(analysis_grade.grade)}>
				<div className="grade-label">Grade</div>
				{analysis_grade.grade}
			</div>
		);
	};

    const render_score_col = (label, value, desc)=>{
        return(
            <Col>
                {render_score(label, value, desc)}
            </Col>
        );
    };

    const render_score = (label, value)=>{
        return(
            <div className={"score-box " + get_color_class(value)}>
                <p className="score-desc">{label}</p>
                <div className="score-value">{Math.round(value) + "%"}</div>
                
            </div>
        );
    };

	// Ask AI shows when on_ask_ai is given. PDF Export and Share show only when the parent can export the analysis:
	// a site analysis has no PDF report yet, so SiteView passes no on_pdf_export.
	const render_export_buttons = ()=>{
		if(!on_pdf_export){
			return null;
		}

		return (
			<React.Fragment>
				<Button
					variant="primary"
					type="submit"
					onClick={on_pdf_export}
					className="analysis-summary-button pdf-export-button"
					disabled={analyzing || fetching_pdf}>
					PDF Export
				</Button>

				{/* Share is commented out until it does something.
				<Button
					variant="primary"
					type="submit"
					className="analysis-summary-button share-button"
					disabled={analyzing || fetching_pdf}>
					Share
				</Button>
				*/}
			</React.Fragment>
		);
	};

	// The critical findings of the run's pages under one CRITICAL heading (render_site_critical_findings). Nothing when
	// no page has one.
	const render_critical_findings_section = ()=>{
		const rendered = render_site_critical_findings(site_analysis.page_analyses_scoring);
		if(!rendered){
			return null;
		}

		return (
			<Row>
				<Col className="analysis-summary-copy">
					{rendered}
				</Col>
			</Row>
		);
	};

	const render_button_footer = ()=>{
		if(!on_ask_ai && !on_pdf_export){
			return null;
		}

		return (
			<span className='summary-button-footer'>
				{on_ask_ai ? (
					<Button
						variant="primary"
						type="button"
						onClick={on_ask_ai}
						className="analysis-summary-button ask-ai-button"
						disabled={analyzing}>
						Ask AI
					</Button>
				) : null}

				{render_export_buttons()}
			</span>
		);
	};

    return(
        <Card className="site-analysis-results-card analysis-summary-card">
            <Row>
                <Col md={3} className="grade-col">
                    {render_grade_box()}
                </Col>

                <Col md={9}>

                    <Row className="align-items-stretch">
                        {render_score_col(
                            "Answer Readiness",
                            scoring.answer_readiness_score,
                            "How well the page can be used to answer queries."
                        )}
                        {render_score_col(
                            "Semantic Clarity",
                            scoring.semantic_clarity_score,
                            "How clear the meaning and intent of the content is."
                        )}
                    </Row>

                    <Row>
                        {render_score_col(
                            "Entity Clarity",
                            scoring.entity_clarity_score,
                            "How well entities and topics are defined."
                        )}
                        {render_score_col(
                            "Content Depth",
                            scoring.content_depth_score,
                            "How deep and comprehensive the content is."
                        )}
                        {render_score_col(
                            "Technical SEO",
                            scoring.technical_seo_score,
                            "How well the page follows technical SEO practices."
                        )}
                    </Row>

                    
                </Col>
            </Row>

            <Row>
                {render_button_footer()}
            </Row>

            {render_critical_findings_section()}

        </Card>
    );
}

export default SiteAnalysisSummary;